import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import ReactTable  from "react-table";
import {getToken, getDateRange} from '../../storage'
import {DRN} from './daterange'
import {Currency} from '../../utils/currency'
import {ColumnSummation} from '../../utils/misc'
import Select from 'react-select';

class BrandSelect extends React.Component {
  constructor(props){
    super(props)
    
    this.state = {
      current_brand_id : this.props.brand_id,
      brands: []
    }
    this.handleChange = this.handleChange.bind(this)
    this.getBrands()
  }



  getBrands =() =>{
    let apiurl = "/list_brands/?sort_column=name&sort_dir=asc";
    axios({
      url: apiurl,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then(res => {
      this.setState({
        brands: res.data.brands
      });
    });
  }
  handleChange(event){
    this.setState({current_brand_id: event.target.value})
    this.props.brandChange(event.target.value)
  }

  render() {
    let brands = this.state.brands
    let options

    if(brands.length > 0) {
      options = brands.map((brand, index)=>{
          return <option key={brand.id} value={brand.id}>{brand.name}</option>
      })
    }
    let inputValue = typeof this.state.current_brand_id === "undefined" ? this.props.brand_id: this.state.current_brand_id

    return <div className="row">
            <div className="col-sm-2">
            <h4>Brand</h4>
            </div>
            <div className="col-sm-10">
            <select className="form-control" name="brand" onChange={this.handleChange} value={inputValue}>{options}</select>
            </div>
    </div>
  }

}

export default class Sales extends React.Component {
  constructor() {
    super();
    let dateRange = getDateRange()

    this.state = {
      tableState: {},
      data: [],
      pages: null,
      loading: true,
      dateRange : dateRange
    };
    
    
    document.title = "Brand Item Sales"
  }



    downloadReport = (report_type) => {
      return   axios({
        url: report_type,
        method: 'get',
        responseType: 'blob',
        onDownloadProgress: progressEvent => {
          let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
          this.setState({downloadPercent:percentCompleted})
        },
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      })
    }


    download = (xls_url) =>{
      this.setState({downloading_invoices:true,})

      let apiurl = xls_url
      let dateRange = this.state.dateRange
      if(dateRange) {
        let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
        let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
        let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
        let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
        apiurl = apiurl + "?start_date="+start_date+"&end_date="+end_date
      }
      let brand_id = this.state.brand_id
      if(typeof brand_id !== "undefined" && brand_id !== null) {
        apiurl = apiurl + '&brand_id='+brand_id
      }
      let client  = this.state.client
      if(typeof client !== "undefined" && client !== null) {
        apiurl = apiurl + '&client_id='+client.id
      }

      this.downloadReport(apiurl).then((response)=> {
        this.setState({submitting_rate_sales:false})

        let disposition = response.headers['content-disposition']
        let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        this.setState({downloadPercent:undefined})
      }).catch((err)=> {
        this.setState({submitting_rate_sales:false, downloadPercent:undefined})
        if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

        }
      })
    }

  componentDidMount() {
    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.brand_id !== "undefined") {
       let brand_id = this.props.match.params.brand_id
       this.setState({brand_id: brand_id})
    }
  }

  invoiceFormat =(row) =>{
    let link = "/invoices/edit/"+row.original.invoice.serial
    return <a href={link} target="_blank">Invoice {row.original.invoice.serial}</a>
  }
  profitFormat =(row)=> {

    let quantity=parseFloat(row.original.quantity), selling_rate=parseFloat(row.original.selling_basic_rate), purchase_rate= parseFloat(row.original.purchase_basic_rate)
    let profit = parseFloat((selling_rate-purchase_rate)*quantity).toFixed(2)
    return parseFloat(profit)
  }

  fetchData =(state, instance, dateRange=this.state.dateRange, brand_id=this.state.brand_id, client=this.state.client)=> {
    this.setState({ loading: true });
    let apiurl = "/list_items_sales_by_brand/?page=" + state.page + '&page_size='+state.pageSize;
    if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
        apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
        apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
    }
    if(brand_id) {
      apiurl = apiurl + '&brand_id='+ brand_id
    }
    if(client) {
      apiurl = apiurl + '&client_id=' + client.id
    }
    if(dateRange) {
      let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
      let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
      let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
      let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
      apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
    }
    this.setState({tableState:state})
    axios({
      url: apiurl,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then(res => {
      this.setState({
        data: res.data.item_sales,
        pages: res.data.pages,
        loading: false
      });
    }).catch((err)=>{
      this.setState({loading:false, data:[], pages:null})
    })
  }

  applyDateRange=(dateRange)=>{
    this.fetchData(this.state.tableState, {}, dateRange)
  }

  handleClientChange = (value)=> {
    this.setState({client: value})
    this.fetchData(this.state.tableState, {}, this.state.dateRange, this.state.brand, value)
  }

  handleBrandChange=(brand)=>{
    this.setState({brand_id: brand})
    this.props.history.push("/reports/items_sale_report/"+brand)
    this.fetchData(this.state.tableState, {}, this.state.dateRange, brand)
  }

  handleTrclick=(state,row, column, instance) =>{
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/reports/item_sale_report/'+row.original.item__id)
      },
      style: {
        cursor:'pointer'
      }
    }
  }

  renderClientName(option){
    return <span>{option.name} {option.city}</span>
  }


  getClients =(input)=> {

    if(!input) {
      return Promise.resolve({ options: [] });
    }

    return   axios({
        url: '/list_clients/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.clients}
      }).catch((err)=> {

        return Promise.resolve({ options: [] });
      })
}



  render() {
    let purchaseHeader = <span><Currency /> Purchase</span>
    let salesHeader = <span><Currency /> Sales</span>
    let profitHeader =<span><Currency /> Profit</span>
    const { data, pages, loading } = this.state;
    const columns = [
      {Header:'Item Name', accessor: 'name', sortable:true , Cell:(row)=>(<div className="text-primary">{row.original.name}</div>)},
      {Header:'Total Items', accessor: 'sales', sortable:true, Cell:(row)=>(<div className="text-right">{row.original.sales}</div>)},
      {Header: purchaseHeader, accessor: 'purchase_amount',
        sortable:true, Cell:(row)=>(<div className="text-right">{row.original.purchase_amount}</div>),
        Footer:<ColumnSummation data={data} sumof='purchase_amount' />
      },
      {Header: salesHeader, accessor: 'sale_amount', sortable:true,
        Cell:(row)=>(<div className="text-right">{row.original.sale_amount}</div>),
        Footer:<ColumnSummation data={data} sumof='sale_amount' />
      },
      {Header: profitHeader, accessor: 'profit', Cell:(row)=>(<div className="text-right">{row.original.profit}</div>),
      sortable:true, Footer:<ColumnSummation data={data} sumof="profit" />},
    ]
    let brand_id = this.state.brand_id
    let table
    if(typeof brand_id !== "undefined") {
      table = <ReactTable
        noDataText="No Records Found."
        getTrProps={this.handleTrclick}
          columns={columns} manual data={data}
          pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
    }


    return <div >
    <section className="medium">
      <div className="row">
        <div className="col-sm-3">
          <h3>Brand Item Sales</h3>
        </div>

        <div className="col-sm-3">
              <Select.Async multi={false} onChange={this.handleClientChange} valueRenderer={this.renderClientName}
              optionRenderer={this.renderClientName} value={this.state.client} valueKey="id" labelKey="name"
              loadOptions={this.getClients} backspaceRemoves={true} placeholder="Select Client"/>

        </div>

        <div className="col-sm-3">
          <BrandSelect brand_id={brand_id} brandChange={this.handleBrandChange}/>
        </div>
        <div className="col-sm-3 ">
          <DRN applyDateRange={this.applyDateRange} dateRange={this.state.dateRange} />
        </div>
      </div>
    </section>
    <div className="row">
      <div className="col-sm-12">
        <div className="text-right"><button className="btn btn-default btn-sm" onClick={(e)=>{this.download("export_salereport_format_a")}}>Download xls</button></div>
        <div className="table-responsive">
          {table}
        </div>

      </div>
    </div>
      </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/report/itembybrandsalesummary.js